import "./sliderSection.scss";
import Slider from "react-slick";
import HeroBanner from "../../../../assets/images/hero-banner.png";
import SliderArrow from "../../../../assets/icons/slider-arrow.svg";
import SliderArrowRight from "../../../../assets/icons/slider-right-icon.svg";
import SliderWhiteArrow from "../../../../assets/icons/slider-whtie-arrow.svg";
import { NavLink } from "react-router-dom";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="slider-arrow-design next-arrow-design" onClick={onClick}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6128 7.57003L7.71687 13.7524M1.32959 7.57003H13.6128H1.32959ZM13.6128 7.57003L7.71687 1.3877L13.6128 7.57003Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="slider-arrow-design prev-arrow-design" onClick={onClick}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6128 7.57003L7.71687 13.7524M1.32959 7.57003H13.6128H1.32959ZM13.6128 7.57003L7.71687 1.3877L13.6128 7.57003Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

export default function SliderSection() {
  const settings = {
    dots: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div>
      <div className="slider-section-all-content-alignment">
        <Slider {...settings}>
          <div className="slider-style">
            <div className="hero-banner-design">
              <img src={HeroBanner} alt="HeroBanner" />
            </div>
            <div className="container">
              <div className="hero-text-all-content-alignment">
                <h1 className="animate__animated animate__slideInUp wow">
                  Immobilienvermittlung{" "}
                </h1>
                <p className="animate__animated animate__slideInUp wow">
                  Sie haben Pläne im Immobilienbereich? Dann begleiten wir auch
                  Sie gern auf Ihrem Weg zum Erfolg! Sie nennen uns Ihre Ziele -
                  wir zeigen Ihnen die Möglichkeiten.
                </p>
                <div className="slider-right-content-button animate__animated animate__slideInUp wow">
                  <NavLink to="/kontakt">
                    <div>
                      <img src={SliderArrowRight} />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-style">
            <div className="hero-banner-design">
              <img src={HeroBanner} alt="HeroBanner" />
            </div>
            <div className="container">
              <div className="hero-text-all-content-alignment">
                <h1 className="animate__animated animate__slideInUp wow">
                  Immobilienvermittlung{" "}
                </h1>
                <p className="animate__animated animate__slideInUp wow">
                  Sie haben Pläne im Immobilienbereich? Dann begleiten wir auch
                  Sie gern auf Ihrem Weg zum Erfolg! Sie nennen uns Ihre Ziele -
                  wir zeigen Ihnen die Möglichkeiten.
                </p>
                <div className="slider-right-content-button animate__animated animate__slideInUp wow">
                  <NavLink to="/kontakt">
                    <div>
                      <img src={SliderArrowRight} />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-style">
            <div className="hero-banner-design">
              <img src={HeroBanner} alt="HeroBanner" />
            </div>
            <div className="container">
              <div className="hero-text-all-content-alignment">
                <h1 className="animate__animated animate__slideInUp wow">
                  Immobilienvermittlung{" "}
                </h1>
                <p className="animate__animated animate__slideInUp wow">
                  Sie haben Pläne im Immobilienbereich? Dann begleiten wir auch
                  Sie gern auf Ihrem Weg zum Erfolg! Sie nennen uns Ihre Ziele -
                  wir zeigen Ihnen die Möglichkeiten.
                </p>
                <div className="slider-right-content-button animate__animated animate__slideInUp wow">
                  <NavLink to="/kontakt">
                    <div>
                      <img src={SliderArrowRight} />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-style">
            <div className="hero-banner-design">
              <img src={HeroBanner} alt="HeroBanner" />
            </div>
            <div className="container">
              <div className="hero-text-all-content-alignment">
                <h1>Immobilienvermittlung </h1>
                <p className="animate__animated animate__slideInUp wow">
                  Sie haben Pläne im Immobilienbereich? Dann begleiten wir auch
                  Sie gern auf Ihrem Weg zum Erfolg! Sie nennen uns Ihre Ziele -
                  wir zeigen Ihnen die Möglichkeiten.
                </p>
                <div className="slider-right-content-button animate__animated animate__slideInUp wow">
                  <NavLink to="/kontakt">
                    <div>
                      <img src={SliderArrowRight} />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
}
